module.exports = __webpack_public_path__ + "static/capo-4da95ac38c055a80baff97a2c4c43b07.png";